<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">
    <img class="sign_bg" src="@/assets/login_image.png" alt="" />

    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <!-- Sign In Form Column -->
      <a-col
        :span="24"
        :md="24"
        :lg="{ span: 16, offset: 0 }"
        :xl="{ span: 16, offset: 2 }"
        class="col-form"
      >
        <a-card
          :bordered="false"
          style="border-radius: 20px; padding: 20px 30px; margin-top: 18%"
        >
          <img class="content_bg" src="@/assets/login_bg.png" alt="" />
          <a-col
            :span="24"
            :md="24"
            :lg="{ span: 24, offset: 0 }"
            :xl="{ span: 12, offset: 2 }"
            class="col-form"
          >
            <a-card
              :bordered="false"
              style="
                border-radius: 20px;
                padding: 0 30px;
                background-color: #ffffff98;
              "
            >
              <div class="login_title_box">修改密码</div>
              <div class="mb-15">
                为保护您的帐号安全，第一次登录请重新设置密码
              </div>
              <a-form id="components-form-demo-normal-login" class="login-form">
                <a-form-item class="mb-10" label="初始密码" :colon="false">
                  <a-input
                    v-model="initPassword"
                    type="password"
                    placeholder="请输入密码"
                  />
                </a-form-item>
                <a-form-item class="mb-5" label="新密码" :colon="false">
                  <a-input
                    v-model="password"
                    type="password"
                    placeholder="请输入由字母或数字组成的8～20位密码"
                  />
                </a-form-item>
                <a-form-item class="mb-5" label="再次确认新密码" :colon="false">
                  <a-input
                    v-model="twoPassword"
                    type="password"
                    placeholder="请输入由字母或数字组成的8～20位密码"
                  />
                </a-form-item>

                <a-form-item>
                  <a-button
                    type="primary"
                    block
                    html-type="submit"
                    class="login-form-button"
                    @click="handleSubmit"
                  >
                    确认修改
                  </a-button>
                </a-form-item>
                <div class="login_out_box">
                  <div class="login_out_btn" @click="loginOut">重新登录</div>
                </div>
              </a-form>
            </a-card>
          </a-col>
        </a-card>
      </a-col>

      <!-- / Sign In Form Column -->

      <!-- Sign In Image Column -->
      <a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
        <!-- <img src="images/img-signin.jpg" alt="" /> -->
      </a-col>
      <!-- Sign In Image Column -->
    </a-row>
  </div>
</template>

<script>
import { updatePassword, logout } from "@/api/user";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      initPassword: "",
      password: "",
      twoPassword: "",
    };
  },
  beforeCreate() {},
  created() {},
  methods: {
    // Handles input validation after submission.
    handleSubmit(e) {
      console.log();

      if (!this.initPassword) {
        this.$message.warning("请输入初始密码");
        return;
      }
      if (this.initPassword != "123456") {
        this.$message.warning("请输入初始密码不正确");
        return;
      }
      if (!this.password) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (!this.twoPassword) {
        this.$message.warning("请确认新密码");
        return;
      }
      if (!this.validatePassword(this.password)) {
        this.$message.warning("请输入输入由字母和数字组成的8～20位密码");
        return;
      }

      if (this.password == this.initPassword) {
        this.$message.warning("新密码与初始密码一致，请修改新密码");
        return;
      }

      if (this.password != this.twoPassword) {
        this.$message.warning("新密码与确认密码不一致");
        return;
      }

      updatePassword({
        password: this.password,
      })
        .then((res) => {
          console.log(res);
          this.$message.success("修改成功");
          this.$emit("getInfo");
        })
        .catch((err) => {});
    },

    validatePassword(password) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/;
      return regex.test(password);
    },
    loginOut() {
      logout()
        .then(() => {
          this.$store.dispatch("user/resetToken");
          localStorage.setItem("token", "");

          localStorage.setItem("userInfo", "");
          localStorage.removeItem("userInfo");
          Cookies.set("JavaInfo", "");
          setToken("");
          this.$router.replace({
            path: "/login",
          });
          // this.router.go(0);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
.code_class {
  display: flex;
}
.login_title_box {
  font-size: 30px;
  font-weight: bold;
}
.login_out_box {
  display: flex;
  align-items: center;
  justify-content: center;
  .login_out_btn {
    color: #0091fb;
    cursor: pointer;
  }
}
</style>
